<template>

<div class="card">
  <div class="card-head">
    <Image 
      v-if="imgName"
      draggable="false"
      :src="$IMG(`assets/images/card/card_${imgName}.png`)" 
      :srcset="`
        ${$IMG('assets/images/card_sm/card_'+imgName+'.png')} 600w,
        ${$IMG('assets/images/card_md/card_'+imgName+'.png')} 768w
      `"
      alt=""
    />
    <div v-if="isNew" class="tag-new">
      NEW
    </div>
  </div>
  <div class="card-body">
    <h5>
      <slot name="title" />
    </h5>
    <p>
      <slot name="description" />
    </p>
    <p class="extra" v-if="$slots.extra">
      <slot name="extra" />
    </p>
    <!-- <button v-on:click="gotoPage" :disabled="!route">
      <template v-if="route">
        <span>
          Demo
        </span>
        <svgCaretRight/>
      </template>
      <template v-else>
        Preparing
      </template>
    </button> -->
    <Button v-on:click="gotoPage" color="accent" size="medium" :disabled="!route">
      <template v-if="route">Demo</template>
      <template v-else>Preparing</template>
      <template v-if="route" v-slot:icon><svgCaretRight /></template>
    </Button>
  </div>

</div>

</template>

<script>
import Button from '@/components/el/Button'
import svgCaretRight from '@/svg/svgCaretRight'

export default {
  props: {
    imgName: [String, undefined],
    route: [Object, undefined],
    isNew: Boolean
  },
  computed: {
    style() {
      return this.imgUrl ? `background-image: url(${this.imgUrl});` : ''
    }
  },
  methods: {
    gotoPage() {
      if (!this.route) return
      this.$router.push(this.route)
    }
  },
  components: {
    svgCaretRight,
    Button
  }
}

</script>

<style lang="scss" scoped>

.card {
  grid-column: span 4;
  background-color: #FFF;
  border-radius: 16px;
  box-shadow: 0px 8px 16px rgba(32, 32, 32, 0.15);
  overflow: hidden;
  @media screen and (max-width: 1104px) {
    grid-column: span 6;
  }
  @media screen and (max-width: 768px) {
    width: 260px;
    flex: none;
  }
  @media screen and (max-width: 540px) {
    width: 244px;
  }
}

.card-head {
  position: relative;
  background-color: var(--gray-200);
  background-size: cover;
  background-position: center center;
  padding-top: 60%;
  @media screen and (max-width: 540px) {
    padding-top: 65%;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    border-top-right-radius: 16px;
    border-top-left-radius: 16px;
  }
}

.card-body {
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  height: 200px;
  @media screen and (max-width: 540px) {
    padding: 20px 16px 16px;

  }
}

h5 {
  font-size: var(--typ-h5);
  color: var(--gray-900);
  margin: 0 0 8px;
  @media screen and (max-width: 768px) {
    font-size: var(--typ-h6);
  }
}

p {
  font-size: var(--typ-body5);
  color: var(--gray-700);
  white-space: pre-line;
  line-height: 1.5;
  margin: 0 0 auto;
  @media screen and (max-width: 768px) {
    font-size: var(--typ-body5);
  }
}

p.extra {
  margin: auto 0 17px;
  font-size: 12px;
  color: var(--gray-500);
}

button {
  flex: none;
  width: 140px;
  @media screen and (max-width: 768px) {
    width: 120px;
    font-size: var(--typ-body4);
  }
}
// button {
//   flex: none;
//   display: inline-flex;
//   align-items: center;
//   border: 1px solid var(--gray-400);
//   border-radius: 8px;
//   width: 140px;
//   padding: 0 16px;
//   margin: 0 auto 0 0;
//   background-color: #FFF;
//   font-size: var(--typ-body2);
//   color: var(--primary-500);
//   height: 44px;
//   justify-content: center;

//   svg {
//     display: block;
//     margin-left: 15px;
//     height: 12px;
//     width: auto;
//   }

//   &[disabled] {
//     pointer-events: none;
//     border: 1px solid var(--gray-300);
//     background-color:  var(--gray-100);
//     color:  var(--gray-500);
//     font-size: var(--typ-body4);
//   }

//   &:hover {
//     border-color: var(--primary-500);
//     background-color: var(--primary-500);
//     color: white;

//     svg {
//       stroke: white;
//     }
//   }

//   &:active {
//     border-color: var(--primary-700);
//     background-color: var(--primary-700);
//   }

//   @media screen and (max-width: 768px) {
//     width: 120px;
//     font-size: var(--typ-body4);
//   }
// }

.tag-new {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 64px;
  height: 32px;
  background-color: var(--info-500);
  border-radius: 4px;
  color: white;
  font-size: 14px;
  font-weight: 700;
  padding: 0 16px;
  display: flex;
  align-items: center;
  user-select: none;
}

</style>